import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TypeOfCoverageComponent } from "./type-of-coverage/type-of-coverage.component";
import { VehicleDetailsComponent } from "@shared/components/vehicle-details/vehicle-details.component";
import { SharedModule } from "@shared/shared.module";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { GET_VEHICLE_USE, SAVE_AS_DRAFT, STORE_COVERAGE_TYPE, STORE_COVERAGE_VEHICLE_DETAILS, INIT_STEP3, STORE_EXTRA_COVER_DETAILS, SET_CURRENT_STEP, GET_SWITCH_SITE, GET_COVER_LIST_LOV, CALCULATE_PREMIUM_PAYLOAD, CALCULATE_PREMIUM, CANCEL_DRAFT, STORE_PREMIUM_CALCULATION_PAYLOAD, VALIDATE_BLACKLIST, UPDATE_COVERAGE_PREMIUM, SKIP_COVERAGE_PREMIUM, STORE_AV_IND_OVERRIDE } from "@store/sat-motor/sat-motor.action";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { Select, Store } from "@ngxs/store";
import { UserResponse } from "@interfaces/user";
import { SimpleModalComponent } from "@shared/components/modal/simple-modal/simple-modal.component";
import { FormatDecimalPipe } from "@shared/pipes/format-decimal/format-decimal.pipe";
import { RemoveCommaPipe } from "@shared/pipes/remove-comma/remove-comma.pipe";
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { Observable } from "rxjs";
import { ConfirmationModalComponent } from "@shared/components/modal/confirmation-modal/confirmation-modal.component";
import { PreviousPolicyErrorPopupComponent } from "@shared/components/modal/previous-policy-error-popup/previous-policy-error-popup.component";
import { OkMessageComponent } from "@shared/components/modal/ok-message/ok-message.component";
import { SaveDraftModalComponent } from "@shared/components/modal/save-draft-modal/save-draft-modal.component";
import { CancelDraftModalComponent } from "@shared/components/modal/cancel-draft-modal/cancel-draft-modal.component";
import { CancelDraftSuccessModalComponent } from "@shared/components/modal/cancel-draft-success-modal/cancel-draft-success-modal.component";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-coverage",
  standalone: true,
  imports: [SharedModule, TypeOfCoverageComponent, VehicleDetailsComponent],
  providers: [DatePipe],
  templateUrl: "./coverage.component.html",
  styleUrl: "./coverage.component.scss",
})
export class CoverageComponent implements OnInit {
  @ViewChild(TypeOfCoverageComponent) typeOfCoverageComponentChild: TypeOfCoverageComponent;
  
  openPreviousPolicyError?: NxModalRef<PreviousPolicyErrorPopupComponent>;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  @Select(SatMotorState.currentTypeOfCoverage) currentTypeOfCoverage$: Observable<SatMotorState>;
  @Select(SatMotorState.coveragePremium) coveragePremium$: Observable<SatMotorState>;

  coverageFmGroup: any;
  alimCustomerInd: boolean;

  userInfo: UserResponse;
  issuanceInfo: any;
  agentDetail: any;
  partnerInfo: any;
  coverList: any;
  vehicleUselov: any;
  isSaved: any;

  decimalFmt: any;
  numberFmt: any;

  subCovList: any;
  subCovPackageList: any;
  extraCoverDetails: any;
  packageDescription: any;
  extraCoverList: any = [];
  rahmahExtraCoverList = [];
  topExtraCoverList = [];
  defaultedExtraCoverList = [];
  fixedDefaultedExtraCoverList = [];
  allSelectedWithRahmahExtraCoverList = [];
  unnamedDriverExtraCoverList = [];
  coverDto: any;
  updateSelectedAndAllListToOPUS: any;
  isWaiver: boolean = false;
  isAllDriver: boolean = false;
  subCovPackageDesc: any;
  agentData: any;
  isSingleAgent: boolean = false;
  hideSaveDraftBtn: boolean = false;
  isQuotationGenerated: any;
  isCoverNoteGenerated: any;
  isUpdateQuotation: any;
  isRetrieveActiveQuotation: any;
  isValidateWaiver: boolean = false;
  activeQuotationDetails : any;
  previousPolicyDetails : any;
  FRUser: boolean = false;

  infoMessageModal?: NxModalRef<SimpleModalComponent>;
  confirmMessageModal?: NxModalRef<ConfirmationModalComponent>;

  constructor(
    private translate: TranslateService,
    private fb: FormBuilder,
    private router: Router,
    private store: Store,
    private readonly dialogService: NxDialogService,
    private datePipe: DatePipe
  ) {
    this.decimalFmt = new FormatDecimalPipe();
    this.numberFmt = new RemoveCommaPipe();
    this.coverageFmGroup = this.fb.group({
      extraCoverDetails: new FormGroup({}),
      vehicleDetails: new FormGroup({}),
      typeOfCoverage: new FormGroup({}),
    });
  }

  ngOnInit(): void {
    window.scroll({ top: 0, left: 0, behavior: 'instant' });
    
    this.isSaved = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step4?.generateQuotation);
    this.userInfo = this.store.selectSnapshot<UserResponse>((state) => state.UserState.user);
    this.agentDetail = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState.motor?.step1?.agentDetail);
    this.issuanceInfo = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState.motor?.step1?.issuance?.issuance);
    this.partnerInfo = this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState.motor?.step2);
    this.alimCustomerInd = this.store.selectSnapshot<string>((state) => state.SatMotorState.motor?.step2?.alimCustomerIndicator) === "YES";
    this.agentData = this.store.selectSnapshot(SatMotorState.motorAgentDetail);
    this.isSingleAgent = this.store.selectSnapshot<any>((state) => state.SatMotorState.isSingleAgent);
    this.isQuotationGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data?.proposalNo);
    this.isCoverNoteGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ?.data?.cnoteNo);
    this.isUpdateQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.updateQuotation);
    this.isRetrieveActiveQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.retrieveQuotation);
    this.activeQuotationDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step1?.activeQuotation);
    this.previousPolicyDetails = this.store.selectSnapshot<UserResponse>(state => state.SatMotorState.previousPolicyDetails);
    this.FRUser = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1.agentDetail.channel === 'FR');

    let isCancelReplace = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.coveragePremium?.cngeNote?.cancelReplaceContractId);
    this.hideSaveDraftBtn = isCancelReplace || this.isQuotationGenerated || this.isCoverNoteGenerated || this.isUpdateQuotation || this.isRetrieveActiveQuotation ? true : false;
    this.setStep();
    this.checkSundriesAgent();
    
    if (this.store.selectSnapshot<any>((state) => state.SatMotorState?.actionType) === "ISSUE")
      if (!this.store.selectSnapshot<UserResponse>((state) => state.SatMotorState?.motor?.step3))
        this.store.dispatch(new INIT_STEP3({}));
      
      let productAccessConfigList;
      if (productAccessConfigList = this.store.selectSnapshot<any>(state => state.SatMotorState?.lov?.productAccessConfigList)) {
        let coverListLov = [];
        productAccessConfigList.forEach((product) => {
          for (let code in product) {
          if (product.hasOwnProperty(code) && code === this.issuanceInfo?.productCode) {
            coverListLov = product[code].coverList;
          }
        }
      });     
       
      this.store.dispatch(new GET_COVER_LIST_LOV({coverListLov: coverListLov})).subscribe((state) => {
        this.coverList = state.SatMotorState.data.step3.coverage.coverListLov;
        this.store.dispatch(new GET_VEHICLE_USE({ productCode: this.issuanceInfo.productCode })).subscribe((state) => {
          this.vehicleUselov = state.SatMotorState.data.step3.coverage.vehicleUseLov;
        });
      });
    }
    
  }
  
  checkSundriesAgent() {
    if (this.agentData && this.agentData?.sundriesAgent) {
      let coveragePremium = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote ?? null);
      let rebateType = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1?.agentAdditional?.rebateType ?? null);
      if (rebateType && coveragePremium) {
        if (!coveragePremium.rebateType) {
          this.reCalculatePremium(rebateType);
        } else if (rebateType !== coveragePremium.rebateType) {
          this.reCalculatePremium(rebateType);
        }

      }
    }
  }

  reCalculatePremium(rebateType) {
    let payloadPremium = this.store.selectSnapshot<any>((state) => state.SatMotorState.data?.step3?.coverage?.coveragePremiumPayload ?? null);

    if (!payloadPremium) {
      payloadPremium = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step3?.coverage?.coveragePremium ?? null);
    }
    
    let updatedPayload = {
      ...payloadPremium,
      cngeNote: {
        ...payloadPremium.cngeNote,
        rebateType: rebateType,
        riskList: [
          {
            ...payloadPremium.cngeNote.riskList[0],
            coverList: [
              {
                ...payloadPremium.cngeNote.riskList[0].coverList[0],
                rebateType: rebateType
              }
            ]
          }
        ]
      }, 
      operator: this.userInfo.userId,
    };

    this.store.dispatch(new STORE_PREMIUM_CALCULATION_PAYLOAD(updatedPayload)).subscribe({
      next: () => {
        this.store.dispatch(new CALCULATE_PREMIUM(updatedPayload));
      }
    });
  }

  goBack() {
    this.router.navigate(["issuance/customer-partner"]);
  }

  setStep() {
    let step;
    if ((this.agentData?.bancaAgent || this.agentData?.sundriesAgent)) {
      step = 4;
    } else {
      step = 3;
    }
    this.store.dispatch(new SET_CURRENT_STEP(step));
  }

  validateVehicleDetails() {
    if (!this.coverageFmGroup.controls["vehicleDetails"].valid) {
      this.coverageFmGroup.controls["vehicleDetails"].markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
      return false;
    }

    // if (!this.validateVariantDesc()){
    //   ScrollToError.scrollToError('input[formControlName="variantDesc"]');
    //   return false;
    // }

    return true;
  }

  validateVariantDesc() {
    let makeModelPrintInd = this.coverageFmGroup.controls["vehicleDetails"].controls["makeModelPrintInd"];
    if (makeModelPrintInd.value) {
      let selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3.coverage.selectedMakeModel);
      let variantDesc = this.coverageFmGroup.controls["vehicleDetails"].controls["variantDesc"];
      if (selectedMakeModel?.variantFullDesc === variantDesc.value) {
        variantDesc.setErrors({"isSame": true});       
        variantDesc.markAllAsTouched(); 
        return false;
      } else {
        variantDesc.setErrors(null);
        variantDesc.updateValueAndValidity();
      }
    }
      
    return true;
  }

  validateTypeOfCoverage(isDraft) {
    if (!this.coverageFmGroup.controls["typeOfCoverage"].valid) {
      this.coverageFmGroup.controls["typeOfCoverage"].markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
      return false;
    }

    if (!this.validateSumInsured()){
      ScrollToError.scrollToError('input[formControlName="sumInsured"]');
      return false;
    }

    let typeOfCoverageForm = this.coverageFmGroup.get("typeOfCoverage");
    let prevNcdVeh = typeOfCoverageForm?.get("prevNcdVeh")?.value;
    
    if (!isDraft && prevNcdVeh !== "NA") {
      const ncdInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1?.coverage?.ncdInfo) || 
                      this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.ncdInfo);

      const isNcdBtdDisabled = this.typeOfCoverageComponentChild.getNcdButton(this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coverageType?.coverCode));

      if (this.store.selectSnapshot<any>(state => state.SatMotorState?.isCancelReplaceCoverNote))
        return true;

      if (!ncdInfo || !isNcdBtdDisabled.nativeElement.disabled) {
        this.dialogService.open(OkMessageComponent, {
          disableClose: true,
          width: "400px",
          data: {
            message: "Please click the Get No Claim Discount button to get the No Claim Discount percentage before proceed.",
          },
        }).afterClosed().subscribe((result) => {
          isNcdBtdDisabled.nativeElement.disabled = false;
          this.typeOfCoverageComponentChild.setNcdButton(false);
        });
        return false;
      }
    }

    return true;
  }

  validateSumInsured() {
    let coverage = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor?.step3?.coverage?.coverageType);
    if (coverage) {
      const coverCode = coverage?.coverCode;
      if (coverCode && ["01" ,"30"].includes(coverCode)) {
        const sumInsured = this.coverageFmGroup.controls["typeOfCoverage"].controls["sumInsured"];
        if (sumInsured.value <= 0) {
          sumInsured.setErrors({"isZero": true});       
          sumInsured.markAllAsTouched(); 
          return false;
        } else {
          sumInsured.setErrors(null);
          sumInsured.updateValueAndValidity();
        }
      }
    }
    return true;
  }

  validateExtraCoverDetails() {
    if(this.typeOfCoverageComponentChild){
      if(!this.typeOfCoverageComponentChild.callTypeOfCoverageComponent("")){
        return false;
      }
    }

    if (!this.coverageFmGroup.controls["extraCoverDetails"].valid) {
      this.coverageFmGroup.controls["extraCoverDetails"].markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
      return false;
    }

    return true;
  }

  validateDriverNameDetails() {
    const driverNameDetails = this.coverageFmGroup.controls["extraCoverDetails"].getRawValue()?.driverNameDetails?.rows;

    if (driverNameDetails) {
      for(let i = 0; i < driverNameDetails.length; i++) {
        let d = driverNameDetails[i];
        if (!d.driverName) {
          this.coverageFmGroup.controls["extraCoverDetails"].controls["driverNameDetails"].setErrors({ 
            ...this.coverageFmGroup.controls["extraCoverDetails"].controls["driverNameDetails"].errors, 'required': true 
          });
          return false;
        }
      }

      let driver = driverNameDetails.map((d) => { return d.driverId + d.driverName; });
      if (new Set(driver).size !== driver.length) {
        this.dialogService.open(SimpleModalComponent, {
          showCloseIcon: false, width: "400px", maxWidth: "400px",
          disableClose: true,
          data: { type: 'WARNING', message: "Duplicate driver name" },
        });
        return false;
      }
    }
    
    return true;
  }

  validateWaiver() {
    const driverNameDetails = this.coverageFmGroup.controls["extraCoverDetails"].getRawValue()?.driverNameDetails?.rows;
    let coveragePremium = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote ?? null);
    this.unnamedDriverExtraCoverList = coveragePremium?.riskList[0]?.coverList[0]?.coverDto?.subCovList.filter(o1 => o1.selected === true && o1.subCoverCode === "A200");


    if (!coveragePremium?.riskList[0]?.coverList[0].vehicleUnNamedDrvrInd
      && coveragePremium?.productCode === '080100'
      && coveragePremium?.riskList[0]?.coverList[0].coverCode === '01'
      && !this.isValidateWaiver && this.unnamedDriverExtraCoverList.length === 0) {
      this.isValidateWaiver = true;
      this.dialogService.open(SimpleModalComponent, {
        showCloseIcon: false, width: "400px", maxWidth: "400px",
        disableClose: true,
        data: { type: 'WARNING', message: "If you have named driver, please key in now or select WAIVER OF COMPULSORY EXCESS IF NOT NAMED DRIVER for RM 20.00" },
      }).afterClosed().subscribe((result) => {
        this.router.navigate(["issuance/summary"]);
      });
    }else{
      this.router.navigate(["issuance/summary"]);
    }
  }

  validateEhailingDriver() {
    const extraCoverPackage = this.coverageFmGroup.controls["extraCoverDetails"].getRawValue()?.extraCoverPackage;
    if (extraCoverPackage) {
      let privateHireCar = extraCoverPackage.find(ex => ex.subCoverCode === 'A202' && ex.selected == true)
      if (privateHireCar) {
        const ehailingDriverDetails = this.coverageFmGroup.controls["extraCoverDetails"].getRawValue()?.ehailingDriverDetails?.rows;
        if (ehailingDriverDetails) {
          let driver = ehailingDriverDetails.map((d) => { return d.driverId + d.driverName; });
          if (!driver.filter(Boolean).length) {
            this.dialogService.open(SimpleModalComponent, {
              showCloseIcon: false, width: "400px", maxWidth: "400px",
              disableClose: true,
              data: { type: 'WARNING', message: "Minimum 1 e-Hailing driver is required." },
            });
            return false;
          }
        }
      }
    }
    return true;
  }

  isNext(currentTypeOfCoverage) {
    if (currentTypeOfCoverage)
      return true;
    return false;
  }

  next() {

    if (!this.validateVehicleDetails()) return;
    if (!this.validateTypeOfCoverage(false)) return;
    if (!this.validateExtraCoverDetails()) return;
    if (!this.validateDriverNameDetails()) return;
    if (!this.validateEhailingDriver()) return;
    this.store.dispatch(new VALIDATE_BLACKLIST({ userId: this.userInfo.userId })).subscribe((stateBlacklist) => {
      if (stateBlacklist.SatMotorState.blacklistResult.success) {
        let vh = this.populateVehicleDetailsData(this.coverageFmGroup.controls["vehicleDetails"].getRawValue());
        this.store.dispatch(new STORE_COVERAGE_VEHICLE_DETAILS(vh)).subscribe((state) => {
          let cv = this.populateTypeOfCoverageData(this.coverageFmGroup.controls["typeOfCoverage"].getRawValue());
          this.store.dispatch(new STORE_COVERAGE_TYPE(cv)).subscribe((state) => {
            this.store.dispatch(new STORE_EXTRA_COVER_DETAILS(this.populateExtraCoverageData(this.coverageFmGroup.controls["extraCoverDetails"].getRawValue()))).subscribe((state) => {
              this.store.dispatch(new UPDATE_COVERAGE_PREMIUM({
                vehicleDetails: { ...vh }, typeOfCoverage: { ...cv }
              })).subscribe(() => {
                this.store.dispatch(new SKIP_COVERAGE_PREMIUM(false));
                this.validateWaiver();
              });
            });
          });
        });
      } else {
        if (!stateBlacklist.SatMotorState.blacklistResult.success) {
          this.validateBlacklistErrorPopup('validateBlacklistPopup', stateBlacklist.SatMotorState.blacklistResult.message)
        }
      }
    });
  }

  saveAsDraft() {

    if (!this.validateVehicleDetails()) return;
    if (!this.validateTypeOfCoverage(true)) return;
    if (!this.validateExtraCoverDetails()) return;
    if (!this.validateDriverNameDetails()) return;
    if (!this.validateEhailingDriver()) return;

    let vh = this.populateVehicleDetailsData(this.coverageFmGroup.controls["vehicleDetails"].getRawValue());
    let cv = this.populateTypeOfCoverageData(this.coverageFmGroup.controls["typeOfCoverage"].getRawValue());
    vh = { ...cv, avInd: cv?.avInd };

    this.store.dispatch(new STORE_COVERAGE_VEHICLE_DETAILS(vh)).subscribe((state) => {
      this.store.dispatch(new STORE_COVERAGE_TYPE(cv)).subscribe((state) => {
        this.store.dispatch(new STORE_EXTRA_COVER_DETAILS(this.populateExtraCoverageData(this.coverageFmGroup.controls["extraCoverDetails"].getRawValue()))).subscribe((state) => {
            this.store.dispatch(new SAVE_AS_DRAFT({ userId: this.userInfo.userId })).subscribe((state) => {
              if (!state?.SatMotorState?.saveAsDraftError) {
                this.dialogService.open(SaveDraftModalComponent, {
                  ariaLabel: "A simple dialog",
                  showCloseIcon: false,
                  disableClose: true,
                  autoFocus: false,
                  width: '90vw',
                  maxWidth: '550px',
                  data: {
                    draftNo: state.SatMotorState.motor.step3.draftNo,
                  },
                })
                .afterClosed().subscribe((result) => {
                  this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
                    window.location.href = state.SatMotorState.data.switchSiteUrl;
                  });
                });
              }else{
                this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
                  showCloseIcon: false,
                  disableClose: true,
                  width: '95%',
                  maxWidth: '400px',
                  data: {
                    type: "e-Quotation Saved Failed",
                    message: state?.SatMotorState?.saveAsDraftError,
                    btnOkLabel: "OK",
                  },
                });
              }
            });
        });
      });
    });
  }

  cancelDraft() {

    this.dialogService.open(CancelDraftModalComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      width: '90vw',
      maxWidth: '550px',
    })
    .afterClosed().subscribe(result => {
      if (result) {
        const data = {
          operator: this.userInfo.userId,
          cngeNote: this.isSaved
        };
        this.store.dispatch(new CANCEL_DRAFT(data)).subscribe(state => {
          if (state) {
            this.dialogService.open(CancelDraftSuccessModalComponent, {
              showCloseIcon: false, 
              disableClose: true,
              autoFocus: false,
              width: "95vh", 
              maxWidth: "350px",
              // data: { message: "Cancel Draft Success" },
            })
            .afterClosed().subscribe((result) => {
              this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
                window.location.href = state.SatMotorState.data.switchSiteUrl;
              });       	      
            });
          }
        });
      }
    });

  }

  onChangedVehicle(data: any) {
    if (data) {
      if (["region", "vehicleUse", "vehicleCapacity", "vehicleChassis", "makeModel"].includes(data?.formControlName)) {
        if (this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3.coverage?.coverageType)) {

          this.store.dispatch(new STORE_AV_IND_OVERRIDE(false));
          
          if (["region", "makeModel"].includes(data?.formControlName)) {
            ["sumInsured", "grossPremium", "excessAmount", "annualPremium", "basicPremium"].forEach((f) => {
              this.coverageFmGroup.controls["typeOfCoverage"].patchValue({
                [f]: null
              });
            });
          }
          this.coverageFmGroup.controls["typeOfCoverage"].patchValue({ avInd: false });
          let coverageType = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coverageType);
          if (["makeModel"].includes(data?.formControlName))
            coverageType = { ...coverageType, resetSumInsuredInd: "1"};

          if(["vehicleUse"].includes(data?.formControlName)) {
            if(["082100", "082101"].includes(this.issuanceInfo.productCode)) {
              this.calculatePremium({ ...coverageType, grossPremium: null }, { resetNamedDriver: true });
              return;
            }
          }

          if(["vehicleChassis"].includes(data?.formControlName)) {
            this.calculatePremium({ ...coverageType, grossPremium: null }, { nwooPolicyCheckingInd: true });
            return;
          }

          this.calculatePremium({ ...coverageType, grossPremium: null }, {});
        }
      }
    }
  }

  onCoverFormChanged(data) {
    this.calculatePremium(data, { nwooPolicyCheckingInd: true });
  }

  calculatePremium(data: any, opt: any) {
    
    let issuanceInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1?.issuance?.issuance);
    let vehicleDetails = this.populateVehicleDetailsData(this.coverageFmGroup.controls["vehicleDetails"].getRawValue());
    let typeOfCoverage = this.populateTypeOfCoverageData({ ...data, ...this.coverageFmGroup.controls["typeOfCoverage"].getRawValue() });
    let coverDto = this.populateCoverDto();

    let prevNcdEffDate, 
        prevNcdExpDate, 
        prevNcdInsurer, 
        prevNcdVeh, 
        // ncdAmt, // cover list
        // ncdPct, // cover list
        ncdEffDate, 
        nextNcdEffDate, 
        nextNcdPct;

    const ncdInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.ncdInfo) || 
                    this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1?.coverage?.ncdInfo);
    if (ncdInfo) {
      prevNcdEffDate = ncdInfo.currPctEffDate;
      prevNcdExpDate = ncdInfo.currPctExpDate;
      nextNcdEffDate = ncdInfo.nextNcdPctEffDate;
      nextNcdPct = ncdInfo.nextNcdPct;

      if (issuanceInfo) {
        ncdEffDate = issuanceInfo?.effectiveDate;
        if (issuanceInfo?.cnoteType === 'NWNN')
          ncdEffDate = new Date().toISOString().slice(0, 10);
      }
    }
    
    vehicleDetails = { 
      ...vehicleDetails, 
      prevNcdEffDate: prevNcdEffDate,
      prevNcdExpDate: prevNcdExpDate,
      ncdEffDate: ncdEffDate,
      nextNcdEffDate: nextNcdEffDate,
      nextNcdPct: nextNcdPct,
      riskType: "VEH", 
      resetSumInsuredInd: typeOfCoverage?.resetSumInsuredInd ?? 0 
    };    

    if (opt?.resetNamedDriver && vehicleDetails.cngeRiskDrvrDtoList) {
      vehicleDetails.cngeRiskDrvrDtoList = vehicleDetails.cngeRiskDrvrDtoList.filter(a => a.cngeRiskDrvrPkDto?.driverType !== "NORM");
    }

    if ('avInd' in typeOfCoverage) {
      vehicleDetails = { ...vehicleDetails, avInd: typeOfCoverage?.avInd};  
    }

    typeOfCoverage = { 
      ...typeOfCoverage, 
      prevNcdEffDate: prevNcdEffDate,
      prevNcdExpDate: prevNcdExpDate,
      ncdEffDate: ncdEffDate,
      nextNcdEffDate: nextNcdEffDate,
      nextNcdPct: nextNcdPct,
    };
    
    this.store.dispatch(new STORE_COVERAGE_VEHICLE_DETAILS(vehicleDetails)).subscribe((state) => {
      this.store.dispatch(new STORE_COVERAGE_TYPE(typeOfCoverage)).subscribe((state) => {
        
        if (vehicleDetails) {
          const mmSi = {
            E: { makeModelSiMin: vehicleDetails?.avEmSiMin, makeModelSiMax: vehicleDetails?.avEmSiMax },
            W: { makeModelSiMin: vehicleDetails?.avWmSiMin, makeModelSiMax: vehicleDetails?.avWmSiMax }
          };
          
          if (typeOfCoverage) {
            if (vehicleDetails?.region) {
              if (mmSi[vehicleDetails.region].makeModelSiMin && mmSi[vehicleDetails.region].makeModelSiMax)
                typeOfCoverage = { ...typeOfCoverage, ...mmSi[vehicleDetails.region]}
            }
          }
        }
        
        let calculatePremiumPayload = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium);
        let subCovList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovList);
        let existingVehicleUnNamedDrvrInd = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coverage?.coveragePremium?.cngeNote?.riskList?.[0]?.coverList?.[0]?.vehicleUnNamedDrvrInd);

        if (!calculatePremiumPayload)
          calculatePremiumPayload = this.store.selectSnapshot<any>((state) => state.SatMotorState?.data?.step3?.coverage?.coveragePremiumPayload);
        
        if (typeOfCoverage) {
          if (typeOfCoverage.prevNcdInsurer)
            prevNcdInsurer = typeOfCoverage.prevNcdInsurer;
          if (typeOfCoverage.prevNcdVeh)
            prevNcdVeh = typeOfCoverage.prevNcdVeh;
        }

        if (calculatePremiumPayload) {
          let cCentric = this.store.selectSnapshot<any>((state) => state?.SatMotorState?.cCentricInfo);
          let motorStep2 = this.store.selectSnapshot<any>((state) => state?.SatMotorState?.motor?.step2);
          if (cCentric && cCentric.clientPartner && !motorStep2) {
            motorStep2 = cCentric.clientPartner;
          }

          let driverList = calculatePremiumPayload?.cngeNote?.riskList?.[0]?.cngeRiskDrvrDtoList;
          if (opt?.resetNamedDriver && driverList) {
            calculatePremiumPayload = {
              ...calculatePremiumPayload,
              cngeNote: {
                ...calculatePremiumPayload.cngeNote,
                riskList: [{
                  ...calculatePremiumPayload.cngeNote.riskList[0],
                  cngeRiskDrvrDtoList:  driverList.filter(a => a.cngeRiskDrvrPkDto?.driverType !== "NORM")
                }]
              }
            };
          }

          if (vehicleDetails) {
            calculatePremiumPayload = {
              ...calculatePremiumPayload,
              cngeNote: {
                ...calculatePremiumPayload?.cngeNote,
                region: vehicleDetails?.region,
                nwooPolicyChecking: !opt?.nwooPolicyCheckingInd
              }
            };
          }

          this.store.dispatch(new STORE_PREMIUM_CALCULATION_PAYLOAD({
            ...calculatePremiumPayload,
            cngeNote: {
              ...calculatePremiumPayload?.cngeNote,
              ...this.copyPreviousPolicy("cngeNote"),
              mtRoadPlacementTblInd: false,
              mtRoadEligibleInd : false,
              riskList: [{
                ...calculatePremiumPayload?.cngeNote?.riskList[0],
                ...vehicleDetails,
                ...this.copyPreviousPolicy("riskList"),
                ...(prevNcdInsurer && {  prevNcdInsurer }),
                ...(prevNcdVeh && { prevNcdVeh }),
                ncdEffDate: ncdEffDate,
                nextNcdEffDate: nextNcdEffDate,
                coverList: [{
                  ...calculatePremiumPayload?.cngeNote?.riskList[0]?.coverList[0],
                  ...typeOfCoverage,
                  coverDto: {
                    ...calculatePremiumPayload?.cngeNote?.riskList[0]?.coverList[0]?.coverDto,
                    ...coverDto
                  },
                  vehicleAlldrvrInd: ["080200", "080300"].includes(this.issuanceInfo.productCode),
                  vehicleUnNamedDrvrInd: (subCovList && subCovList.length > 0 && existingVehicleUnNamedDrvrInd) ||  (!this.activeQuotationDetails && !this.previousPolicyDetails && this.FRUser && !subCovList),
                  ...this.copyPreviousPolicy("coverList"),
                }]
              }],
              ...(motorStep2 && { clientPartner: { ...motorStep2 } }),
              effectiveDate : this.issuanceInfo?.effectiveDate || calculatePremiumPayload?.cngeNote?.effectiveDate,
              expiryDate: this.issuanceInfo?.expiryDate || calculatePremiumPayload?.cngeNote?.expiryDate
            },
            operator: this.store.selectSnapshot(state => state.UserState.user.userId)
          })).subscribe(state => {
            this.store.dispatch(new CALCULATE_PREMIUM(state.SatMotorState.data.step3.coverage.coveragePremiumPayload))
          });          
        } else {
          let mtRoadPlacementTblInd = this.store.selectSnapshot<any>((state) =>  state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote?.mtRoadPlacementTblInd);
          let mtRoadEligibleInd = this.store.selectSnapshot<any>((state) =>  state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote?.mtRoadEligibleInd);
          let cnoteStatus = this.store.selectSnapshot<any>((state) =>  state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote?.cnoteStatus);

          this.store.dispatch(new CALCULATE_PREMIUM_PAYLOAD({
            coverage: {
              cnoteStatus: cnoteStatus,
              mtRoadPlacementTblInd: mtRoadPlacementTblInd,
              mtRoadEligibleInd: mtRoadEligibleInd,
              vehicleDetails: vehicleDetails,
              typeOfCoverage: typeOfCoverage,
              vehicleAlldrvrInd: ["080200", "080300"].includes(this.issuanceInfo.productCode),
              vehicleUnNamedDrvrInd: (!this.activeQuotationDetails && !this.previousPolicyDetails && this.FRUser),
              coverDto: coverDto
            },
            operator: this.userInfo.userId,
          })).subscribe(state => {
            let coveragePremiumPayload = state.SatMotorState.data.step3.coverage.coveragePremiumPayload;

            if (vehicleDetails) {
              coveragePremiumPayload = {
                ...coveragePremiumPayload,
                cngeNote: {
                  ...coveragePremiumPayload?.cngeNote,
                  region: vehicleDetails?.region,
                  nwooPolicyChecking: !opt?.nwooPolicyCheckingInd
                }
              };
            }

            this.store.dispatch(new CALCULATE_PREMIUM({
              ...coveragePremiumPayload,
              cngeNote: {
                ...coveragePremiumPayload?.cngeNote,
                ...this.copyPreviousPolicy("cngeNote"),
                riskList: [{
                  ...coveragePremiumPayload?.cngeNote?.riskList[0],
                  ...this.copyPreviousPolicy("riskList"),
                  coverList: [{
                    ...coveragePremiumPayload?.cngeNote?.riskList[0]?.coverList[0],
                    ...this.copyPreviousPolicy("coverList"),
                  }],
                }]
              }
            }))
          });
        }

      });
    });
  }

  copyPreviousPolicy(level) {
    let coveragePremiumData = this.store.selectSnapshot<any>((state) => state.SatMotorState?.motor?.step3?.coveragePremiumData?.cngeNote);
    if (coveragePremiumData) {
      if (level === "cngeNote") {
        return {
          previousPolicyNo : coveragePremiumData?.previousPolicyNo,
          prevRegion : coveragePremiumData?.prevRegion,
          prevExpDate : coveragePremiumData?.prevExpDate,
          prevType : coveragePremiumData?.prevType,
          prevSubChannel : coveragePremiumData?.prevSubChannel,
          prevQuotationDate : coveragePremiumData?.prevQuotationDate,
          prevEffDate : coveragePremiumData?.prevEffDate,
          prevPostCode : coveragePremiumData?.prevPostCode,
          prevIssueDate : coveragePremiumData?.prevIssueDate,
        };
      } else if (level === "riskList") {
        if (coveragePremiumData?.riskList && coveragePremiumData?.riskList.length) {
          return {
            prevNcdInsurer: coveragePremiumData?.riskList[0]?.prevNcdInsurer,
            prevNcdVeh: coveragePremiumData?.riskList[0]?.prevNcdVeh,
            prevNcdExpDate: coveragePremiumData?.riskList[0]?.prevNcdExpDate,
            prevVehicleCapacity: coveragePremiumData?.riskList[0]?.prevVehicleCapacity,
            prevVehicleUse: coveragePremiumData?.riskList[0]?.prevVehicleUse,
            previousVehicleModelDescp: coveragePremiumData?.riskList[0]?.previousVehicleModelDescp,
          }
        }
        return {};
      } else if (level === "coverList") {
        if (coveragePremiumData?.riskList && coveragePremiumData?.riskList.length) {
          if (coveragePremiumData?.riskList[0] && coveragePremiumData?.riskList[0].coverList && coveragePremiumData?.riskList[0].coverList.length) {
            return {
              prevRenewalBonusAmount: coveragePremiumData?.riskList[0]?.coverList[0]?.prevRenewalBonusAmount,
              prevRenewalBonusPercentage: coveragePremiumData?.riskList[0]?.coverList[0]?.prevRenewalBonusPercentage,
              previousSumInsured: coveragePremiumData?.riskList[0]?.coverList[0]?.previousSumInsured,
              prevNcdPercentage: coveragePremiumData?.riskList[0]?.coverList[0]?.prevNcdPercentage,
              previousMinSumInsured: coveragePremiumData?.riskList[0]?.coverList[0]?.previousMinSumInsured,
              previousMaxSumInsured: coveragePremiumData?.riskList[0]?.coverList[0]?.previousMaxSumInsured,
              prevAnnualPremium: coveragePremiumData?.riskList[0]?.coverList[0]?.prevAnnualPremium,
              prevSumInsured: coveragePremiumData?.riskList[0]?.coverList[0]?.prevSumInsured,
              prevLoadPercentage: coveragePremiumData?.riskList[0]?.coverList[0]?.prevLoadPercentage,
              prevCoverCode: coveragePremiumData?.riskList[0]?.coverList[0]?.prevCoverCode,
            }
          }
        }
        return {};
      }
    }
    return {};
  }
  
  populateVehicleDetailsData(data) {
    let selectedMakeModel = this.store.selectSnapshot<any>((state) => state.SatMotorState.data.step3?.coverage?.selectedMakeModel);
    let makeModelPrintInd = data.makeModelPrintInd ? "Y" : "N";
    let vehicleDetails = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.vehicleDetails);
    let isDataFromView = this.store.selectSnapshot<any>((state) => state.SatMotorState.viewQuotation || state.SatMotorState.updateQuotation);
    let vehicleDetailsData = {
      ...vehicleDetails, ...selectedMakeModel, ...data, 
      vehicleCapacity: this.numberFmt.transform(data.vehicleCapacity),
      vehicleEngine: data?.vehicleEngine ? data?.vehicleEngine.trim() : data?.vehicleEngine,
      vehicleChassis: data?.vehicleChassis ? data?.vehicleChassis.trim() : data?.vehicleChassis,
      vehiclePurchaseDate: this.datePipe.transform(data.vehiclePurchaseDate, 'yyyy-MM-dd'),
      makeModelPrintInd: makeModelPrintInd,
      makeModelDesc: this.retrieveMakeModelDesc(data,vehicleDetails,isDataFromView,selectedMakeModel),
      importStatus: selectedMakeModel?.importStatus,
      vehModelNvic: selectedMakeModel?.vehModelCodeNvic,
      vehicleModel: selectedMakeModel?.vehModelCodeNvic,
      nvicNo: selectedMakeModel?.nvicCode,
    };
    let ncdInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.ncdInfo);
    if (!ncdInfo) {
      let ncdEnqInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.ncdEnquiryDetails);
      if (ncdEnqInfo) 
        vehicleDetailsData = { ...vehicleDetailsData, ismRefNo: ncdEnqInfo?.ismRefNo }
    } else {
      vehicleDetailsData = { ...vehicleDetailsData, ismRefNo: ncdInfo?.ismRefNo }
    }
    return vehicleDetailsData;
  }

  retrieveMakeModelDesc(data, vehicleDetails, isDataFromView, selectedMakeModel) {
    let makeModelDescRet = "";
    if (this.issuanceInfo?.cnoteType === "RN") {
      makeModelDescRet = data?.makeModelDesc || vehicleDetails?.makeModelDesc || isDataFromView?.riskList[0]?.makeModelDesc;
    }
    else if (isDataFromView && isDataFromView?.riskList[0]?.makeModelPrintInd === "Y") {
      makeModelDescRet = isDataFromView?.riskList[0]?.makeModelDesc;
    }
    else if (isDataFromView && isDataFromView?.riskList[0]?.makeModelPrintInd === "N") {
      makeModelDescRet = data?.makeModelDesc || selectedMakeModel?.piamMakeCodeDesc;
    } else {
      makeModelDescRet = selectedMakeModel?.piamMakeCodeDesc || vehicleDetails?.makeModelDesc;
    }
    return makeModelDescRet;
  }

  populateTypeOfCoverageData(data) {
    let coverageType = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coverageType);
    let typeOfCoverageData = { 
      ...coverageType, ...data, 
      sumInsured: this.numberFmt.transform(data.sumInsured), excessAmount: this.numberFmt.transform(data.excessAmount),
      basicPremium: this.numberFmt.transform(data.basicPremium), annualPremium: this.numberFmt.transform(data.annualPremium), 
      ncdAmount: this.numberFmt.transform(data.ncdAmount), ncdPercentage: this.numberFmt.transform(data.ncdPercentage)
    };
    if (data.grossPremium) {
      typeOfCoverageData = {
        ...typeOfCoverageData, grossPremium: this.numberFmt.transform(data.grossPremium), 
      };
    }
    return typeOfCoverageData;
  }

  populateCoverDto() {
    let coverageType = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.coverageType);
    let coverDto = null;

    //if (coverageType?.coverCode === '20') { //third party : remove because impact 1 Allianz MRW
      coverDto = this.store.selectSnapshot<any>((state) => {
        let riskList = state.SatMotorState.motor.step3?.coverage?.coveragePremium?.cngeNote?.riskList;
        let coverList = riskList?.[0]?.coverList;
        return coverList?.[0]?.coverDto ?? null;
      });
  //  }

    if (coverDto) {
      let ncdInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step3?.coverage?.ncdInfo);
      if (!ncdInfo) {
        let ncdEnqInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState.ncdEnquiryDetails);
        if (ncdEnqInfo) 
          coverDto = { ...coverDto, ncdEnquiryResponseCode: ncdEnqInfo?.ismResCode || null, tmpNcdConfirmationError: false }
      } else {
        coverDto = { ...coverDto, ncdEnquiryResponseCode: ncdInfo?.ismResCode || null, tmpNcdConfirmationError: false }
      }
    }

    return coverDto;
  }

  populateExtraCoverageData(data) {
    let driverNameDetails = data?.driverNameDetails?.rows?.map((d, i) => { return { ...d, driverAge: d.driverAge !== "N/A" ? d.driverAge : 0 , driverSeq: i+1 } });
    let ehailingDriverDetails = data?.ehailingDriverDetails?.rows?.filter((a) => a.driverId || a.driverName)?.map((d, i) => { return { ...d, driverSeq: i+1 } });
    return {
      ...data, 
      driverNameDetails: {
        rows: driverNameDetails,
        vehicleUnNamedDrvrInd: data.driverNameDetails?.waiverInd,
        vehicleAlldrvrInd: data.driverNameDetails?.allDriverInd
      }, 
      ehailingDriverDetails: {
        rows: ehailingDriverDetails
      }
    };
  }

  populateDriverNameData() {
    let driverNameForm = this.coverageFmGroup.controls["driverNameForm"].getRawValue();
    const namedDriverList = driverNameForm.rows
    let cngeRiskDrvrDtoList = namedDriverList.map((driver) => {
      let driverName;
      if (driver.driverName) {
        driverName = driver.driverName;
      } else if (driver?.cngeRiskDrvrPkDto?.driverName) {
        driverName = driver.cngeRiskDrvrPkDto.driverName;
      }

      let cngeRiskDrvrPkDto = {
        cngeRiskDrvrPkDto: {
          driverName: driverName ? driverName : "",
          driverType: "NORM",
        },
        driverId: driver.driverId,
        driverAge: driver.driverAge,
        driverSeq: driver.driverSeq,
      };

      return cngeRiskDrvrPkDto;
    });
    return cngeRiskDrvrDtoList;
  }

  validateBlacklistErrorPopup(popup_type: any, error: any) {
    this.openPreviousPolicyError = this.dialogService.open(PreviousPolicyErrorPopupComponent, {
      ariaLabel: "A simple dialog",
      width: '400px',
      showCloseIcon: false,
      disableClose: true,
      data: {
        popup_type: popup_type,
        popup_error: error
      },
    });
  }

  hasCoverNoteAccess() {
    if (this.userInfo && this.userInfo.menuAccess) {
      if (this.userInfo.menuAccess.includes('SAT_MT_CN')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

}
